import { useEffect, useState } from 'react';
import { useConfiguratorStore } from '@/state/configuratorStore';
import { supabaseEnabled } from '@/lib/supabase';

export function TopBar() {
  const capture = useConfiguratorStore(s => s.capture);
  const saveDesign = useConfiguratorStore(s => s.saveDesign);
  const shareDesign = useConfiguratorStore(s => s.shareDesign);
  const saveStatus = useConfiguratorStore(s => s.saveStatus);
  const [shareOpen, setShareOpen] = useState(false);

  useEffect(() => {
    if (saveStatus.kind !== 'saved') return;
    setShareOpen(true);
    const ms = saveStatus.shareUrl ? 8000 : 4000;
    const t = window.setTimeout(() => setShareOpen(false), ms);
    return () => window.clearTimeout(t);
  }, [saveStatus]);

  return (
    <header className="topbar">
      <div className="topbar__brand">
        <a
          className="topbar__logo"
          href="https://urbanqode.com"
          target="_blank"
          rel="noreferrer"
          title="UrbanQode — Build better. Grow faster."
          aria-label="UrbanQode.com"
        >
          <img src="/assets/UrbanQode_Logo.png" alt="UrbanQode" width={32} height={32} />
        </a>
        <div className="topbar__brand-text">
          <span className="topbar__name">Kit Studio</span>
          <a
            className="topbar__by"
            href="https://urbanqode.com"
            target="_blank"
            rel="noreferrer"
            title="UrbanQode — Build better. Grow faster."
          >
            by <strong>UrbanQode.com</strong>
          </a>
        </div>
      </div>

      <div className="topbar__center">
        <span className="topbar__tag">3D Teamwear Configurator</span>
        <span className="topbar__badge topbar__badge--uq" title="urbanqode.com">
          UrbanQode
        </span>
        {!supabaseEnabled && (
          <span className="topbar__badge" title="Set VITE_SUPABASE_* in .env to enable cloud save">
            local mode
          </span>
        )}
        {saveStatus.kind === 'saving' && <span className="topbar__badge">Saving…</span>}
        {saveStatus.kind === 'saved' && (
          <span className="topbar__badge topbar__badge--ok" title={saveStatus.shareUrl}>
            Saved{saveStatus.mode === 'local' ? ' locally' : ''}
          </span>
        )}
        {saveStatus.kind === 'error' && (
          <span className="topbar__badge topbar__badge--err" title={saveStatus.message}>
            Save failed
          </span>
        )}
      </div>

      <div className="topbar__actions">
        <button type="button" className="btn btn--ghost" onClick={() => void capture()}>
          Download
        </button>
        <button
          type="button"
          className="btn btn--ghost"
          onClick={() => void saveDesign()}
          disabled={saveStatus.kind === 'saving'}
        >
          Save design
        </button>
        <button
          type="button"
          className="btn btn--primary"
          onClick={() => void shareDesign()}
          disabled={saveStatus.kind === 'saving'}
        >
          Share
        </button>
      </div>

      {shareOpen && saveStatus.kind === 'saved' && (
        <div className="share-toast" role="status">
          {saveStatus.shareUrl ? (
            <>
              <span>Link copied</span>
              <code>{saveStatus.shareUrl}</code>
            </>
          ) : (
            <span>Design saved to this browser</span>
          )}
          <button type="button" className="share-toast__close" onClick={() => setShareOpen(false)}>
            ×
          </button>
        </div>
      )}
    </header>
  );
}
